/* eslint-disable no-console */

// Events
import { MODAL_CLOSED, MODAL_OPEN, MOUNT_COMPONENTS } from 'events';
import { component } from 'picoapp';

import choozy from 'utils/choozy';
// Utils
import { clear, stringToNode } from 'utils/node';
import { dispatch } from 'utils/theme';

const MODAL_ID = 'product_info_modal';

export default component((node, ctx) => {
  const { skeletonLoader } = choozy(node);

  const shadowDOM = new DocumentFragment();
  const cache = {};

  shadowDOM.appendChild(skeletonLoader);

  const fetchContent = async (handle) => {
    const url = `/products/${handle}?view=info-modal-content`;
    const options = {
      method: 'GET',
    };

    try {
      const response = await fetch(url, options);
      const text = await response.text();
      const html = stringToNode(text);

      return Promise.resolve(html);
    } catch {
      return Promise.reject();
    }
  };

  const render = async ({ productHandle }) => {
    clear(node);

    node.appendChild(skeletonLoader);

    try {
      cache[productHandle] = cache[productHandle] || (await fetchContent(productHandle));
    } catch (err) {
      console.error(err);
      return;
    }

    node.appendChild(cache[productHandle].cloneNode(true));

    ctx.emit(MOUNT_COMPONENTS);

    // Add timeout to prevent flickering from mounting components
    setTimeout(() => {
      shadowDOM.appendChild(skeletonLoader);
    }, 200);

    dispatch('view-item', {
      productHandle,
      overlay: true,
    });
  };

  ctx.on(MODAL_CLOSED, (state, { id }) => {
    if (id !== MODAL_ID) return;

    const form = node.querySelector('[data-product-form]');
    const { formId, productId } = form.dataset;

    document.dispatchEvent(new CustomEvent(`${productId}:${formId}:unmount`));
  });

  ctx.on(MODAL_OPEN, (state, { id, props }) => {
    if (id !== MODAL_ID) return;

    render(props);
  });
});
